import { getBoxPathname } from '@/utils/lesson/box';
import { useParams, useSearchParams } from 'react-router-dom';

export const useCoursePathnameUpdater = () => {
  const { slug, lessonId } = useParams();
  const [searchParams] = useSearchParams();

  const mountUrl = (pathname: string) =>
    `${pathname}?${searchParams.toString()}`;

  const updateCoursePathname = (currentSlug?: string) => {
    if (slug === currentSlug || !currentSlug) return;
    const pathname = getBoxPathname(currentSlug, lessonId);
    const newUrl = mountUrl(pathname);
    window.history.replaceState(null, '', newUrl);
  };

  return { updateCoursePathname };
};
